module.exports = __webpack_public_path__ + "img/erweima_zc.ac918348.png";